import _ea from "./in-app-message-manager.js";
import r from "../managers/braze-instance.js";
var se = {
  aa: null,
  l: !1,
  ea: function ea() {
    return se.p(), se.aa || (se.aa = new _ea(r.g(), r.P(), r.j(), r.ir())), se.aa;
  },
  p: function p() {
    se.l || (r.h(se), se.l = !0);
  },
  destroy: function destroy() {
    se.aa = null, se.l = !1;
  }
};
export default se;